import { GetCulpritPropertyInsurancePropType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritPropertyInsurance/getCulpritPropertyInsurance.type';
import { getCulpritPropertyInsuranceFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritPropertyInsurance/getCulpritPropertyInsuranceFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritPropertyInsuranceOptions = (
  {id}: GetCulpritPropertyInsurancePropType,
) => {
  return queryOptions({
    queryKey: ['culprit-property-insurance-get', id],
    queryFn: () => getCulpritPropertyInsuranceFunction({id}),
  });
};
